/** @jsx jsx */
import {
  Box,
  ColumnConfig,
  EmptyState,
  EmptyStateListWhite,
  Flex,
  List,
  ListCellsWrapper,
  ListHeader,
  ListHeaderCell,
  ListItem,
  ListItemCell,
  Paragraph,
} from "@eworkit/iris";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { ITask } from "@/data/contracts";

interface ContractTasksProps {
  tasks: ITask[];
}

export const ContractTasks: FC<ContractTasksProps> = ({ tasks }) => {
  const { t } = useTranslation("session");

  const cols = useMemo(() => {
    const name: ColumnConfig = { sx: { width: ["100%", "50%", "40%"] } };
    const startDate: ColumnConfig = { sx: { width: ["100%", "25%", "30%"] } };
    const endDate: ColumnConfig = { sx: { width: ["100%", "25%", "30%"] } };

    return { name, startDate, endDate };
  }, []);

  return !tasks || tasks.length === 0 ? (
    <Box sx={{ py: 120 }} px="sm">
      <EmptyState
        icon={<EmptyStateListWhite />}
        title={t("CONTRACTS.TASKS.NO_MATCHING_TASKS")}
        content={t("CONTRACTS.TASKS.NO_MATCHING_TASKS_DESCRIPTION")}
      />
    </Box>
  ) : (
    <Flex flexDirection="column" gap="xs">
      <ListHeader>
        <ListCellsWrapper>
          <ListHeaderCell columnConfig={cols.name}>{t("CONTRACTS.TASKS.LIST.NAME")}</ListHeaderCell>
          <ListHeaderCell columnConfig={cols.startDate}>{t("CONTRACTS.TASKS.LIST.START_DATE")}</ListHeaderCell>
          <ListHeaderCell columnConfig={cols.endDate}>{t("CONTRACTS.TASKS.LIST.END_DATE")}</ListHeaderCell>
        </ListCellsWrapper>
      </ListHeader>

      <List>
        {tasks.map((task, index) => (
          <ListItem key={index}>
            <ListCellsWrapper>
              <ListItemCell columnConfig={cols.name}>
                <Paragraph bold ellipsis>
                  {task.name}
                </Paragraph>
              </ListItemCell>
              <ListItemCell columnConfig={cols.startDate}>
                <Paragraph>{task.startDate}</Paragraph>
              </ListItemCell>
              <ListItemCell columnConfig={cols.endDate}>
                <Paragraph>{task.endDate}</Paragraph>
              </ListItemCell>
            </ListCellsWrapper>
          </ListItem>
        ))}
      </List>
    </Flex>
  );
};
